// validate if the MPAN is valid using Check Digit Modulus algorithm
// ONLY perform this check if the MPAN is UK based
// and the length is exactly 13 characters
export const validateUkMpan = (mpan: string): boolean => {
    const primes = [3, 5, 7, 13, 17, 19, 23, 29, 31, 37, 41, 43]
    let sum = 0
    if (mpan.length < 13 || mpan.length > 13) {
        return false
    }
    if (mpan.length - 1 === primes.length) {
        for (let i = 0; i < primes.length; i += 1) {
            sum += parseInt(mpan.charAt(i), 10) * primes[i]
        }
        return (sum % 11) % 10 === parseInt(mpan.charAt(12), 10)
    }
    return false
}
